
import {refCount, publishReplay, map, catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { plainToClass } from "class-transformer";

import { DuePayment } from '../models';
import { BaseService } from './base.service';





import * as _ from 'lodash';

@Injectable()
export class DuePaymentsService extends BaseService {

  private baseServiceUrl: string;
  private currentDuePayments: Observable<DuePayment[]>;

  constructor(
    private http: HttpClient) {
    super();
    this.baseServiceUrl = '/Api/DuePayments/';
  }

  getAllForCurrentUser(refresh: boolean = false): Observable<DuePayment[]> {
    if (!this.currentDuePayments || refresh) {

      let headers = this.getDefaultHttpHeaders();

      let url: string = this.baseServiceUrl + 'GetAllForCurrentUser';

      this.currentDuePayments = this.http
        .get(url, { headers: headers }).pipe(
        catchError((err, c) => this.handleErrorAndThrow(err)),
        map((res: Object[]) => plainToClass(DuePayment, res)),
        publishReplay(1),
        refCount(),);
    }

    return this.currentDuePayments;
  }

}
